import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import '../style/finalReport.css';
import { ButtonComponent } from '../component/Common';
import Swal from 'sweetalert2';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Accordion, AccordionItem as Item } from '@szhsin/react-accordion';
import Select from 'react-select';
const docsUrl = process.env.REACT_APP_DOCS_URL;

const AccordionItem = ({ header, ...rest }) => (
    <Item
        {...rest}
        header={
            <>
                {header}
                <img className={'chevron'} src="/chevron-down.svg" alt="Chevron Down" />
            </>
        }
        className='item'
        buttonProps={{
            className: ({ isEnter }) =>
                `${'itemBtn'} ${isEnter && 'itemBtnExpanded'}`,
        }}
        contentProps={{ className: 'itemContent' }}
        panelProps={{ className: 'itemPanel' }}
    />
);

const FormDetailView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const formId = searchParams.get('id');
    const [data, setData] = useState(null);
    const [requirementData, setRequirementData] = useState(null);
    const [selectedReason, setSelectedReason] = useState(null);
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const [feedbackData, setFeedbackData] = useState(null);

    const reasonList = [
        { value: 'Accepted', label: 'Accept' },
        { value: 'Resubmission Required', label: 'Resubmission Required' },
        { value: 'Rejected', label: 'Reject' },
    ];
    useEffect(() => {
        const fetchData = async (formId) => {
            try {
                const response = await api.get(`/get-form-detail-view/${formId}`);
                setData(response.data.allReports);
                setRequirementData(response.data.requirementData);
                setFeedbackData(response.data.feedback)
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData(formId);
    }, []);

    const excludedKeys = ['id', 'userId', 'createdAt', 'updatedAt', 'isActive', 'personalDetailsId', 'EmploymentDetailsId', 'ExpensesDetailsId', 'emiDetailsId', 'formId'];

    const formattedKeys = (key) => {
        const lowerWithSpaces = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
        return lowerWithSpaces.charAt(0).toUpperCase() + lowerWithSpaces.slice(1);
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedReason(selectedOption);
    };

    const handleTextareaChange = (e) => {
        setFeedbackMessage(e.target.value);
    };

    const sendFeedback = async () => {
        try {
            if (selectedReason == null) {
                Swal.fire({
                    icon: 'error',
                    iconColor: '#ab1717',
                    title: 'Please select reason.',
                    showConfirmButton: false,
                    timer: 2000
                })
                return
            } else if (feedbackMessage == '') {
                Swal.fire({
                    icon: 'error',
                    iconColor: '#ab1717',
                    title: 'Please write appropriate message.',
                    showConfirmButton: false,
                    timer: 2000
                })
                return
            } else {
                const feedbackData = {
                    reason: selectedReason.value,
                    feedback: feedbackMessage,
                };

                const result = await api.post(`/save-feedback/${formId}`, feedbackData);
                if (result.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: result.data.message,
                        iconColor: '#008000',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    navigate('/mga-staff-portal/dashboard')
                }
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    const backButton = () => {
        navigate(-1);
    };


    const renderData = (data) => {
        if (typeof data === 'object' && data !== null) {
            return Object.entries(data).map(([key, value], index) => {
                if (Array.isArray(value)) {
                    return value.map((item, index) => excludedKeys.includes(key) ? null : (
                        <div key={index} className="nested-array">
                            <div className="sub-heading"><h3>{index + 1}. {formattedKeys(key)} :</h3></div>
                            {renderData(item)}
                        </div>
                    ));
                }
                if (typeof value === 'object' && value !== null) {
                    return Object.entries(value).map(([key1, value1], index) => excludedKeys.includes(key1) ? null : (
                        <>
                            <div key={index} className="nested-object">
                                <div className="label">{formattedKeys(key1)} :</div>
                                <div className="value">{renderData(value1)}</div>
                            </div>
                        </>
                    ));
                }
                if (typeof value === 'string' && /\.(jpg|png|pdf)$/i.test(value)) {
                    return (
                        <div key={index} className="nested-object">
                            <div className="label">{formattedKeys(key)} :</div>
                            <div className="value">
                                <a href={`${docsUrl}/uploads/${value}`} download target="_blank" rel="noopener noreferrer">
                                    {value.split('/').pop()}
                                </a>
                            </div>
                        </div>
                    );
                }

                return excludedKeys.includes(key) ? null : (
                    <>
                        <div key={index} className="nested-object">
                            <div className="label">{formattedKeys(key)} :</div>
                            <div className="value">{renderData(value)}</div>
                        </div>
                    </>
                )
            });
        } else {
            return (
                typeof data === 'string' && /\.(jpg|png|pdf)$/i.test(data) ? (
                    <a href={data} download target="_blank" rel="noopener noreferrer">
                        Download {data.split('/').pop()}
                    </a>
                ) : (
                    <span>{data != null ? data.toString() : 'N/A'}</span>
                )
            );
        }
    };

    if (!data) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className="final-report">
                <div className="parent-div">
                    <div className="child1" style={{ display: "flex", justifyContent: "start" }}>
                        <ButtonComponent
                            onClick={backButton}
                            name="Go Back"
                        />
                    </div>                    
                    <div className="child2"  style={{ display: "flex", justifyContent: "center" }}><h1>Final Report</h1></div>
                    <div className="child2"></div>
                </div>
                
                <div className="mortgage-enquiry">
                    <>
                        <h2>Loan Details</h2>
                        <div className="details-table">
                            {renderData(requirementData)}
                        </div>
                    </>
                </div>
                <div className='accordion-div'>
                    <h2>Review Forms</h2>
                    <div className='accordion'>
                        <Accordion allowMultiple transition transitionTimeout={250}>
                            {Object.entries(data).map(([key, value], index) => (
                                <AccordionItem header={`Applicant ${index + 1}`}>
                                    <div key={index} className="mortgage-enquiry">
                                        {/* <h2>{formattedKeys(key)}</h2> */}
                                        {Object.entries(value).map(([key, value1], index) => (
                                            <>
                                                <h2>{formattedKeys(key)}</h2>
                                                <div className="details-table">
                                                    {renderData(value1)}
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
                {feedbackData === null && (
                    <div className='feedback-div'>
                        <h2>Send Feedback</h2>
                        <div className='reason-div'>
                            <Select
                                className="Select Reason"
                                options={reasonList}
                                value={selectedReason}
                                onChange={handleSelectChange}
                                placeholder="Select a Reason"
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        width: "40%",
                                        margin: "0",
                                    }),
                                }}
                            />
                            <textarea
                                name="postContent"
                                placeholder="Enter Feedback Message"
                                wrap="soft"
                                value={feedbackMessage}
                                onChange={handleTextareaChange}
                            />
                            <ButtonComponent name="Send Feedback" onClick={sendFeedback} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FormDetailView;